import styled from "styled-components";

import { Container, FramerMotionWrapper } from "components/ui";

import { media } from "constants/media";

export const Wrapper = styled.section`
    background-color: var(--color-orange-50);
    padding: 0 0 320px;
    position: relative;

    ${media.mdUp} {
        background-color: transparent;
        padding: 0 0 170px;
    }

    ${media.lgUp} {
        min-height: 947px;
        padding: 0 0 210px;
    }
`;

export const StyledContainer = styled(Container)`
    padding: 68px 24px 0;
    position: relative;
    z-index: var(--z-index-homepage-section);

    ${media.mdUp} {
        padding: 96px 24px 0;
    }

    ${media.lgUp} {
        padding: 210px 24px 0;
    }
`;

export const Content = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 16px;
    grid-column: span 4;
    text-align: center;
    z-index: var(--z-index-homepage-section);

    ${media.mdUp} {
        align-items: flex-start;
        text-align: left;
    }

    ${media.lgUp} {
        grid-column: span 5;
    }
`;

export const Description = styled.p`
    font-family: var(--font-secondary);
    font-size: var(--type-heading-5-font-size);
    line-height: var(--type-heading-5-line-height);
`;

export const Links = styled.ul`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 24px;
    list-style: none;

    ${media.mdUp} {
        flex-direction: row;
    }
`;

export const LinksItem = styled.li`
    align-items: stretch;
    width: 100%;

    a {
        display: flex;
        justify-content: center;
    }

    ${media.mdUp} {
        align-items: flex-start;
        width: auto;

        a {
            display: inline-flex;
            justify-content: flex-start;
        }
    }
`;

export const StyledFramerMotionWrapper = styled(FramerMotionWrapper)`
    aspect-ratio: 1 / 1;
    position: relative;
    width: 100%;
`;

export const Road = styled.div<{ inView: boolean }>`
    background-image: url("/images/homepage-bg-road-mobile.svg");
    background-position: top center;
    background-repeat: no-repeat;
    height: 2299px;
    left: calc(50% - 76px);
    opacity: ${({ inView }) => (inView ? 1 : 0)};
    position: absolute;
    top: calc(100% - 67px);
    transform: translateX(-50%);
    transform-origin: top left;
    transition: opacity 0.5s ease;
    transition-delay: 0.25s;
    width: 1155px;
    z-index: var(--z-index-homepage-bg);

    ${media.mdUp} {
        background-image: url("/images/homepage-bg-road-tablet.svg");
        height: 1820px;
        left: calc(50% + -150px);
        top: calc(100% - 234px);
        width: 1536px;
    }

    ${media.lgUp} {
        background-image: url("/images/homepage-bg-road-desktop-new.svg");
        height: 3566px;
        left: calc(50% + 120px);
        top: calc(100% - 258px);
        width: 2635px;
    }
`;

export const RingWrapper = styled.div`
    aspect-ratio: 1 / 1;
    position: absolute;
    right: 50%;
    top: calc(100% - 127px);
    transform: translateX(72%);
    width: 464px;
    z-index: var(--z-index-homepage-bg);

    ${media.mdUp} {
        bottom: auto;
        right: -302px;
        top: -178px;
        transform: none;
        width: 801px;
    }

    ${media.lgUp} {
        right: -490px;
        top: -200px;
        width: 1200px;
    }

    ${media.xlUp} {
        right: -443px;
    }
`;

export const HeroImageWrapper = styled.div`
    clip-path: circle(60%);
    height: 100%;
    position: relative;
    right: 46px;
    scale: 0.6;
    width: 100%;

    @media (min-width: 375px) {
        right: 0;
        scale: 0.7;
    }

    ${media.mdUp} {
        clip-path: ellipse(90% 70% at right);
        right: 86px;
        scale: 0.69;
    }

    ${media.lgUp} {
        right: 126px;
        scale: 0.6;
    }

    ${media.xlUp} {
        clip-path: none;
        right: 0;
        scale: 0.65;
    }
`;

export const WorldclassWorkplaceImageWrapper = styled.div`
    bottom: 97px;
    height: 106px;
    left: 45px;
    position: absolute;
    width: 80px;

    ${media.mdUp} {
        bottom: 135px;
        height: 146px;
        left: 139px;
        width: 110px;
    }

    ${media.lgUp} {
        bottom: 204px;
        height: 187px;
        left: 245px;
        width: 140px;
    }

    ${media.xlUp} {
        bottom: 170px;
        left: 704px;
    }
`;
